var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fi-table',{staticClass:"loan-schedule-usage-statement-list",attrs:{"fields":_vm.fields,"items":_vm.transactions,"empty-label":_vm.$t("notFound"),"responsive":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return _vm._l((items),function(transaction){return _c('loan-schedule-usage-statement-list-item',{key:transaction.id,attrs:{"transaction":transaction}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }